import React from 'react'

const Languages = () => {
    return (
        <div className='containerHBorder' id={3}>
            <div className='subtitle'>
                <span>LANGUAGES</span>
            </div>
            <p style={{ textAlign: 'center' }}>
            • Spanish (Native) • English (Proficient C2) • German (Beginner) • Portuguese (Beginner)
            </p>
        </div>
    )
}

export default Languages